import { keepPreviousData } from '@tanstack/react-query';
import { useFilteredQuery } from '@/hooks/use-filtered-query';
import { filtersQuestion, type Filters } from '@/lib/filters-schema';
import { fetchCampaignCard, fetchCampaignList } from '@/services/campaigns-api';
import type { CampaignCard, CampaignListRow } from '@/services/api-types';

export function useCampaignList(filters: Filters) {
  return useFilteredQuery<CampaignListRow[]>({
    queryKey: ['campaigns', 'list', filtersQuestion(filters)],
    queryFn: async () => (await fetchCampaignList(filters)).data,
    staleTime: 60_000, placeholderData: keepPreviousData,
  });
}
export function useCampaignCard(filters: Filters, id: string | null) {
  return useFilteredQuery<CampaignCard | null>({
    queryKey: ['campaigns', 'card', id, filtersQuestion(filters)],
    queryFn: async () => (await fetchCampaignCard(filters, id!)).data,
    staleTime: 60_000, placeholderData: keepPreviousData, enabled: Boolean(id),
  });
}
